import React from 'react';
import { FormFieldGroupProps } from './GenericFormTypes';
import { FormFieldRenderer } from './FormFieldRenderer';

/**
 * Form Field Group Component
 * Renders a group of related form fields with styling
 */

export const FormFieldGroup = <T,>({
  config,
  data,
  onFieldChange,
  validationErrors,
  onClearError,
}: FormFieldGroupProps<T>) => {
  const { title, gradientClass, borderClass, fields } = config;

  if (fields.length === 0) {
    return null;
  }

  return (
    <div className={`bg-gradient-to-r ${gradientClass} p-5 rounded-xl border ${borderClass}`}>
      <h3 className="text-sm font-medium text-gray-700 mb-4">{title}</h3>
      <div className="grid grid-cols-1 gap-4">
        {fields.map(field => (
          <FormFieldRenderer
            key={field.key}
            field={field}
            data={data}
            onFieldChange={onFieldChange}
            validationError={validationErrors[field.key]}
            onClearError={onClearError}
          />
        ))}
      </div>
    </div>
  );
};
